var _style, _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordionLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 120.9",
    style: {
      enableBackground: "new 0 0 1000 120.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 730.9,
    y: 2.9,
    className: "st0",
    width: 21.1,
    height: 115.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499.6,2.9h52.8c24.5,0,36.7,16.9,36.7,34.2c0,14.5-7.9,27.8-23.4,32.9l29.8,48h-24.7L545,74.3h-24.3V118h-21.1 V2.9z M548.5,56.2c12.7,0,19.1-7.4,19.1-17.3s-6.1-16.3-18.6-16.3h-28.3v33.5L548.5,56.2L548.5,56.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M614.6,2.9h41.3c38.2,0,55.9,25.3,55.9,55.6S693.4,118,653.1,118h-38.5V2.9z M653.2,98.3 c26.3,0,37-17.6,37-39.3s-9.7-36.3-34.4-36.3h-20.2v75.6H653.2L653.2,98.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M771,60.4C771,27.3,791.2,0,827.9,0s56.9,27.3,56.9,60.4s-20.2,60.5-56.9,60.5S771,93.4,771,60.4z M827.9,101.5 c23.4,0,35.4-17.8,35.4-41.1s-12-40.9-35.4-40.9s-35.4,17.6-35.4,40.9C792.6,83.7,804.6,101.5,827.9,101.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.7,60.4C366.7,27.3,387,0,423.6,0s56.9,27.3,56.9,60.4s-20.2,60.5-56.9,60.5S366.7,93.4,366.7,60.4z  M423.6,101.5c23.4,0,35.4-17.8,35.4-41.1s-12-40.9-35.4-40.9s-35.4,17.6-35.4,40.9C388.3,83.7,400.3,101.5,423.6,101.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.6,2.9 46.5,2.9 85.3,98.8 49.3,98.8 41.5,118 115.1,118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.8,26.9 0,118 22.1,118 47.8,54.2  "
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.2,61.2C243.2,25,265.7,0,300.4,0c27.5,0,48.2,15.6,49.7,42.1h-21.5c-1.2-14.1-12.3-22.7-28.8-22.7 c-22.5,0-35.2,16.6-35.2,40.9c0,21.9,10.2,41.1,34.9,41.1c16.4,0,28.9-8.6,29.6-26.1h21.5c-1.3,30.3-24,45.6-52.6,45.6 C260.3,120.9,243.2,92.4,243.2,61.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.2,61.2C120.2,25,142.7,0,177.4,0c27.5,0,48.2,15.6,49.7,42.1h-21.5c-1.2-14.1-12.3-22.7-28.8-22.7 c-22.5,0-35.2,16.6-35.2,40.9c0,21.9,10.2,41.1,34.9,41.1c16.4,0,28.9-8.6,29.6-26.1h21.5c-1.3,30.3-24,45.6-52.6,45.6 C137.3,120.9,120.2,92.4,120.2,61.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M904,2.9h24.8L979,85.3V2.9h21.1V118h-24.2L925,34.6V118h-21L904,2.9L904,2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionLogoWhite);
export default __webpack_public_path__ + "static/media/accordion_logo_white.01145de712c266faa9e42ed6a79ad3f8.svg";
export { ForwardRef as ReactComponent };